import React, { useEffect, useContext, useState } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Spinner from 'react-bootstrap/Spinner';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { Fragment } from 'react';

import { getTitle, getDecodedCookie } from '../../helpers/helperApp';

function Apartados(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ estadoFormPrin, saveEstadoFormPrin ] = useState("");
    const [ estadoFormHijo, saveEstadoFormHijo ] = useState("");

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, saveFormularioHijo , handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, regIniciales, handleDeleteItemPrin, handleSubmitPrin, resetFormPrin, handleSelectFormPrin } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{   
                    document.title = getTitle(confPantalla.config.trad, confPantalla.apartados.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        saveEstadoFormPrin(confPantalla.apartados.padre.estadoform);
                        saveEstadoFormHijo(confPantalla.apartados.hijo.estadoform)                             
                        // ***** Carga inicial de registros *****
                        if( registrosPrin ){
                            if( registrosPrin.length === 0 ){
                                saveLoadingTable(true);
                                regIniciales(saveRegistrosPrin, confPantalla.apartados.padre.urls);
                                saveFormularioPrin(confPantalla.apartados.padre.modelform);
                                saveFormularioHijo(confPantalla.apartados.hijo.modelform);     
                            }
                        }  
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state ){
                            if( "idPrin" in props.location.state || "idHijo" in props.location.state ){
                                handleLastReg(props.location.state.idPrin, props.location.state.idHijo, confPantalla.apartados.padre.urls, confPantalla.apartados.hijo.urls, confPantalla.apartados.padre.tabla, props.location.state.estadoFormPrin, saveEstadoFormPrin, saveEstadoFormHijo);     
                            }                        
                        }                      
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
            document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])
 
    const ruta = typeof formularioPrin?.ruta === "string" ? formularioPrin.ruta : "";
    const treeLevel = ruta.includes(">")
        ? Math.max(
            0,
            ruta
                .split(">")
                .map((item) => item.trim())
                .filter((item) => item !== "").length - 1
        )
        : 0;

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section titulo={ confPantalla.apartados.section.titulo } icono={ confPantalla.apartados.section.icono } col={ confPantalla.apartados.section.col } idPrin={ formularioPrin.id } wiki={ confPantalla.apartados.section.wiki } >
                            <Formulario 
                                        estadoForm= { estadoFormPrin }
                                        loading=    { loadReg ? true : false }
                                        btnNew={ confPantalla.apartados.padre.btnform.new }
                                        btnSave={ confPantalla.apartados.padre.btnform.save }
                                        btnSaveAndNew={ confPantalla.apartados.padre.btnform.saveandnew }
                                        btnDelete={ confPantalla.apartados.padre.btnform.delete }
                                        btnClone={ confPantalla.apartados.padre.btnform.clone }
                                        handleSubmit = { e => handleSubmitPrin(e, confPantalla.apartados.padre.urls, confPantalla.apartados.padre.modelform, confPantalla.apartados.padre.tabla, confPantalla.apartados.hijo.modelform, confPantalla.apartados.title) } 
                                        formulario = { formularioPrin } 
                                        resetForm = { e => resetFormPrin(confPantalla.apartados.padre.modelform, true, confPantalla.apartados.padre.tabla) } 
                                        handleDeleteItem = { e => handleDeleteItemPrin(undefined, confPantalla.apartados.padre.urls, confPantalla.apartados.padre.modelform, confPantalla.apartados.padre.tabla, confPantalla.apartados.title) } 
                            >         
                            <h4>{ formularioPrin.ruta }</h4>   
                                <FormRow clases="" >
                                <MiSelect  
                                        estadoForm=  { estadoFormPrin }
                                        val=         { formularioPrin.pad  }   
                                        loading=     { loadReg ? true : false }
                                        id=          { confPantalla.apartados.padre.controles.pad.id }    
                                        name=        { confPantalla.apartados.padre.controles.pad.name }   
                                        label=       { confPantalla.apartados.padre.controles.pad.label }    
                                        placeholder= { confPantalla.apartados.padre.controles.pad.placeholder }
                                        col=         { confPantalla.apartados.padre.controles.pad.col } 
                                        isClearable= { confPantalla.apartados.padre.controles.pad.isclearable }
                                        isSearchable={ confPantalla.apartados.padre.controles.pad.issearchable }
                                        dataType=    { confPantalla.apartados.padre.controles.pad.datatype }
                                        data=        { confPantalla.apartados.padre.controles.pad.data }
                                        required=    { confPantalla.apartados.padre.controles.pad.required } 
                                        disabled=    { confPantalla.apartados.padre.controles.pad.disabled }
                                        readOnly =   { confPantalla.apartados.padre.controles.pad.readonly }
                                        disablethisid={confPantalla.apartados.padre.controles.pad.disablethisid}
                                        formulario = { formularioPrin } 
                                        change=      { handleSelectFormPrin }                                                    
                                    />                                    
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.apartados.padre.controles.nom.id }   
                                        type=       { confPantalla.apartados.padre.controles.nom.type }  
                                        name=       { confPantalla.apartados.padre.controles.nom.name }   
                                        label=      { confPantalla.apartados.padre.controles.nom.label }                                                       
                                        placeholder={ confPantalla.apartados.padre.controles.nom.placeholder }    
                                        col=        { confPantalla.apartados.padre.controles.nom.col } 
                                        required=   { confPantalla.apartados.padre.controles.nom.required }
                                        readonly=   { confPantalla.apartados.padre.controles.nom.readonly }                                                
                                        disabled=   { confPantalla.apartados.padre.controles.nom.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.nom_en }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.apartados.padre.controles.nom_en.id }   
                                        type=       { confPantalla.apartados.padre.controles.nom_en.type }  
                                        name=       { confPantalla.apartados.padre.controles.nom_en.name }   
                                        label=      { confPantalla.apartados.padre.controles.nom_en.label }                                                       
                                        placeholder={ confPantalla.apartados.padre.controles.nom_en.placeholder }    
                                        col=        { confPantalla.apartados.padre.controles.nom_en.col } 
                                        required=   { confPantalla.apartados.padre.controles.nom_en.required }
                                        readonly=   { confPantalla.apartados.padre.controles.nom_en.readonly }                                                
                                        disabled=   { confPantalla.apartados.padre.controles.nom_en.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    /> 
                                </FormRow>
                                <FormRow>
                                    <FormInput                                                        
                                        estadoForm= { estadoFormPrin }
                                        value=      { formularioPrin.cod1 }
                                        loading=    { loadReg ? true : false }
                                        id=         { confPantalla.apartados.padre.controles.cod1.id }   
                                        type=       { confPantalla.apartados.padre.controles.cod1.type }  
                                        name=       { confPantalla.apartados.padre.controles.cod1.name }   
                                        label=      { confPantalla.apartados.padre.controles.cod1.label }                                                       
                                        placeholder={ confPantalla.apartados.padre.controles.cod1.placeholder }    
                                        col=        { confPantalla.apartados.padre.controles.cod1.col } 
                                        required=   { confPantalla.apartados.padre.controles.cod1.required }
                                        readonly=   { confPantalla.apartados.padre.controles.cod1.readonly }                                                
                                        disabled=   { confPantalla.apartados.padre.controles.cod1.disabled }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />
                                    <FormInput
                                        estadoForm= { estadoFormPrin }
                                        value=      { treeLevel }
                                        loading=    { loadReg ? true : false }
                                        id=         { "tree_level" }   
                                        type=       { "text" }  
                                        name=       { "nivel" }   
                                        label=      { "Nivel" }                                                       
                                        placeholder={ confPantalla.apartados.padre.controles.cod1.placeholder }    
                                        col=        { confPantalla.apartados.padre.controles.cod1.col } 
                                        required=   { confPantalla.apartados.padre.controles.cod1.required }
                                        readonly=   { true}                                                
                                        disabled=   { true }
                                        change=     { e => handleInputForm(e, formularioPrin, saveFormularioPrin) }
                                        onBlur=     {null} 
                                    />

                                </FormRow>                            
                            </Formulario>                   
                            <MiDataTable
                                formulario={formularioPrin} 
                                estadoForm= { estadoFormPrin }
                                id={"apartados"}
                                columnas={confPantalla.apartados.padre.datatable.columns}
                                data={registrosPrin}
                                buttons={confPantalla.apartados.padre.datatable.buttons}
                                ordering={confPantalla.apartados.padre.datatable.ordering}
                                order={confPantalla.apartados.padre.datatable.order}
                                searching={confPantalla.apartados.padre.datatable.searching}
                                paging={confPantalla.apartados.padre.datatable.paging}
                                select={confPantalla.apartados.padre.datatable.select}
                                pagelength={confPantalla.apartados.padre.datatable.pagelength}
                                handleEditReg= { e => handleEditRegPrin(e, confPantalla.apartados.padre.urls, confPantalla.apartados.hijo.urls, confPantalla.apartados.padreshijos, confPantalla.apartados.hijo.modelform, confPantalla.apartados.padre.tabla) }
                                handleDeleteItem={ e => handleDeleteItemPrin(e, confPantalla.apartados.padre.urls, confPantalla.apartados.padre.modelform, confPantalla.apartados.padre.tabla, confPantalla.apartados.title) }
                                saveLoadingTable={ saveLoadingTable }
                                loadingTable={loadingTable}
                                columnactions={confPantalla.apartados.padre.datatable.columnactions.title}
                                traduction={confPantalla.config.trad.components.datatable}
                            />                                                                                                             
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Apartados